<template>
	<div class="summary-page">
		<div class="container-fluid fixed-width-lg">
			<ProgressBar :currentStep="1" class="container-padding" />
		</div>
		<div class="container-fluid fixed-width-lg px-3">
			<div class="row order-total">
				<div class="col-6 m-0 p-0">
					<h2>Order Total:</h2>
				</div>
				<div class="col-6 m-0 p-0 text-right">
					<h2>{{totalCartValue() | toCurrency(2)}}<sup>*</sup></h2>
					<span class="price-note">*estimated price, subject to availability and delivery</span>
				</div>
			</div>
		</div>
		<div class="container-fluid fixed-width-lg px-3">
			<div class="row delivery-note pb-3">
				<div class="col-6 m-0 p-0">
					<span>Delivery costs vary</span>
				</div>
				<div class="col-6 m-0 p-0 text-right">
					<a href="#" class="delivery-modal-link" v-b-modal.delivery-modal>View delivery options</a>
				</div>
			</div>
			<div class="continue-btn">
				<b-button variant="primary" to="/order/details">Continue to details</b-button>
			</div>
		</div>
		<div class="container-fluid container-padding" style="background-color: #fafafa; height: 100%">
			<div class="container-fluid p-0 fixed-width-card-list">
				<div class="back-div">
					<router-link to="/" class="back-btn">
						<img src="@/assets/icon-general-back.svg" class="back-arrow" />
						<span class="back-text">Food to order</span>
					</router-link>
				</div>
				<span class="small-title">Order Summary</span>
			</div>
		</div>
		<div class="container-fluid p-0" style="background-color: #fafafa; height: 100%">
			<div class="container-fluid p-0 fixed-width-card-list">
				<b-card-group class="" deck>
					<SummaryProductCard v-for="item in cart.items" :key="item.variant.articleId" v-bind:cartItem="item" />
				</b-card-group>
			</div>
			<div class="container-fluid p-0 fixed-width-lg">
				<div class="continue-btn">
					<b-button variant="primary" to="/order/details">Continue to details</b-button>
				</div>
			</div>
		</div>
		<DeliveryModal />
	</div>
</template>

<script>
	import SummaryProductCard from "@/components/ProductGrid/SummaryProductCard.vue";
	import ProgressBar from "@/components/Common/ProgressBar.vue";
	import DeliveryModal from "@/components/Common/DeliveryModal.vue";
	import { mapGetters, mapState } from 'vuex';

	export default {
		name: "SummaryPage",
		components: {
			SummaryProductCard,
			ProgressBar,
			DeliveryModal,
		},
		data() {
			return {
				layout: [],
				index: 0,
				expanded: false,
				item: {
					product: { quantity: 0 },
				},
			};
		},
		created() {
			if (this.cartIsEmpty()) {
				this.$router.push('/');
			}
		},
		mounted() {
		},
		computed: {
			...mapState(['cart']),
			...mapGetters(['cartIsEmpty', 'totalCartValue'])
		},
		methods: {},
	};
</script>
<style lang="scss" scoped>
	@media (min-width: 576px) {
		.card-deck {
			margin: 0;
		}
	}

	@media (min-width: 768px) and (orientation: landscape) {
		.summary-product-card {
			width: 65%;
		}
	}
	.delivery-modal-link {
		a

	{
		color: #967c59;
	}

	}

	@include media(">lg") {
		.fixed-width-lg {
			max-width: 35%;
		}

		.fixed-width-card-list {
			max-width: 60%;
		}

		.summary-product-card {
			max-width: 50%;
		}
	}

	.container-padding {
		padding: 30px;
	}

	.small-title {
		font-size: 13px;
		letter-spacing: 1.5px;
		font-weight: 500;
		text-transform: uppercase;
	}

	.continue-btn {
		padding: 40px 15px 60px 15px;
	}

	sup {
		top: -0.25em;
	}

	.price-note {
		font-size: 12px;
		font-weight: 300;
		font-style: italic;
		line-height: 1;
	}

	.delivery-note {
		font-size: 16px;
		font-weight: 300;
		margin-left: 18px;
		margin-right: 22px;
		margin-top: 20px;
		padding-top: 15px;
		border-top: 1px solid #f5f5f5;
		a

	{
		text-decoration: underline;
		font-weight: normal;
	}

	}

	.order-total {
		margin-left: 18px;
		margin-right: 22px;
		margin-top: 39.5px;
		padding-top: 12px;
		border-top: 1px solid #f5f5f5;
	}

	@include media("<sm") {
		.vue-grid-item {
			height: fit-content !important;
			transform: none !important;
			position: relative !important;
			width: 100% !important;
		}

		.vue-grid-layout {
			height: 100% !important;
		}

		.back-div {
			display: none;
		}
	}

	.back-arrow {
		width: 25px;
		height: 25px;
		transform: translate(0px, -4px);
		margin-right: 10px;
	}

	.back-div {
		transform: translate(-35px,0px);
		margin-bottom: 20px;
	}

	@media (max-width: 992px) {
		.back-arrow {
			margin-right: 4px;
		}

		.back-div {
			transform: translate(-29px, 0px);
		}
	}

	.back-btn {
		display: flex;
		text-decoration: none;
	}

	.back-text {
		font-size: 13px;
		letter-spacing: 1.5px;
		font-weight: 500;
		text-transform: uppercase;
		color: #424242;
	}
	
</style>
